import React from 'react'
import {Typography,Button, Grid} from '@mui/material';
import colors from '../colors'  
import {texts} from '../general/texts'

const RegistrationPasswordTextValidator = (props) => 
{
    const regexes = [{length:/^.{6,}$/}, {symbols:/[!@#\$%\^&\*]/g},{upperCase:/[A-Z]/g},{lowerCase:/[a-z]/g}, {numbers:/[0-9]/g}]
    
    const [upperCase, setUpperCase] = React.useState({
        text: ' ' + texts["password-rules-uppercase"] + ', ',
        color : colors.gray
    })
    
    const [lowerCase, setLowerCase] = React.useState({
        text: ' ' + texts["password-rules-lowercase"] + ', ',
        color : colors.gray
    })
    const [symbols, setSymbols] = React.useState({
        text: texts["and-separator"] + ' ' + texts["password-rules-symbol"],
        color : colors.gray
    })
    const [numbers, setNumbers] = React.useState({
        text: ' ' + texts["password-rules-number"],
        color : colors.gray
    })
    const [length, setLength] = React.useState({
        text: texts["password-rules-length"] + ', ',
        color : colors.gray
    })
    
    React.useEffect(()=> {
        
        if(props.password.match(regexes[0].length))
        {
            setLength({...length, color:colors.green})
        }
        else if(!props.password.match(regexes[0].length))
        {
            setLength({...length, color:colors.gray})
        }

        if(props.password.match(regexes[1].symbols))
        {
            setSymbols({...symbols, color:colors.green})
        }
        else if(!props.password.match(regexes[1].symbols))
        {
            setSymbols({...symbols, color:colors.gray})
        }

        if(props.password.match(regexes[2].upperCase))
        {
            setUpperCase({...upperCase, color:colors.green})
        }
        else if(!props.password.match(regexes[2].upperCase))
        {
            setUpperCase({...upperCase, color:colors.gray})
        }

        if(props.password.match(regexes[3].lowerCase))
        {
            setLowerCase({...lowerCase, color:colors.green})
        }
        else if(!props.password.match(regexes[3].lowerCase))
        {
            setLowerCase({...lowerCase, color:colors.gray})
        }    

        if(props.password.match(regexes[4].numbers))
        {
            setNumbers({...numbers, color:colors.green})
        }
        else if(!props.password.match(regexes[4].numbers))
        {
            setNumbers({...numbers, color:colors.gray})
        } 
    },[props.password])

    return(
        <Grid container item justifyContent='flex-start' mb={7}>
            <Typography sx={{color: colors.gray, textAlign:'left'}} variant="caption">
                <Typography sx={{fontFamily:"GerberaLight", fontSize:'0.8rem'}}>{texts["password-rules-beginning"]}</Typography>
                <Grid container gap={0.5}>
                    <Typography style={{color:length.color, fontFamily:"GerberaLight", fontSize:'0.8rem'}}>{length.text}</Typography>
                    <Typography style={{color:upperCase.color, fontFamily:"GerberaLight", fontSize:'0.8rem'}}>{upperCase.text}</Typography>
                </Grid>
                <Grid container gap={0.5}>
                    <Typography style={{color:lowerCase.color, fontFamily:"GerberaLight", fontSize:'0.8rem'}}>{lowerCase.text}</Typography>
                    <Typography style={{color:numbers.color, fontFamily:"GerberaLight", fontSize:'0.8rem'}}>{numbers.text}</Typography>
                </Grid>
                <Typography style={{color: symbols.color, fontFamily:"GerberaLight", fontSize:'0.8rem'}}>{symbols.text}</Typography>
            </Typography>
        </Grid>    
    )
}

export default RegistrationPasswordTextValidator
